var map = {
	"./Acintyo_5_11zon.webp": 5529,
	"./DA_7_11zon.webp": 2073,
	"./Enorvision_1_11zon.webp": 2578,
	"./Gods Club_6_11zon.webp": 9932,
	"./HBF_11zon.webp": 2936,
	"./Indus Expert_2_11zon.webp": 6770,
	"./Partner": 9862,
	"./Partner.css": 4471,
	"./Partner.jsx": 9862,
	"./Taiiki_4_11zon.webp": 8726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1310;